import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { ToastProvider } from './components/Toast.jsx';
import { AuthProvider } from './components/AuthContext.jsx';
import './styles/app.css';
import './styles/collections.css';
import './styles/catalogCategories.css';
import './styles/institutionHeader.css';
import './styles/libraryTheme.css';
import './styles/pressPublications.css';
import './styles/postcardLocalities.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider><AuthProvider><App /></AuthProvider></ToastProvider>
    </BrowserRouter>
  </React.StrictMode>
);
